import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "PaisPage",
    data() {
        let ss = new MainService();
        return {
            msg: "PaisPage",
            ss: ss,
            ajax: {
                "url": ss.indexPais(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Pais', name: 'Pais', title: 'País' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            paiss: [],
            pais: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newPais() {
            this.pais = {};
            this.$refs['frm-pais'].show();
        },
        showPais(id) {
            this.isLoading=true;
            this.ss.showPais(id).then(
                (result) => {
                    let response = result.data;
                    this.pais = response.data;
                    this.$refs['view-pais'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPais() {
            this.$refs['frm-pais'].show();
            this.$refs['view-pais'].hide();
        },
        cancelPais() {
            if (this.pais.id) {
                this.$refs['view-pais'].show();
            }
            this.$refs['frm-pais'].hide();
        },
        savePais() {
            this.ss.storePais(this.pais).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-pais'].hide();
                    this.$refs['datatable-pais'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePais() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyPais(this.pais)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-pais'].hide();
                                this.$refs['datatable-pais'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Pais').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPais(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }
    }
};
